import React from 'react';

import { withCars } from '../../../shared/containers/containerCars'

import Counter from './../../../shared/items/static/counter'

const CarsCounterWrapper = props => {
  const { filterCountUnits } = props

  return !!filterCountUnits || filterCountUnits === 0
    ? <Counter count={filterCountUnits} />
    : null
}

export default withCars(React.memo(CarsCounterWrapper))
